import React from 'react';

export const Field = ({ label, htmlFor, children }: { label: string; htmlFor?: string; children: React.ReactNode }) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={htmlFor} className="text-[0.8rem] font-medium tracking-[0.02em] text-white/60">
      {label}
    </label>
    {children}
  </div>
);

export const TextInput = ({ className = '', ...props }: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input
    className={`w-full rounded-[0.6rem] border border-white/10 bg-white/5 px-3.5 py-2.5 font-sans text-sm text-white placeholder:text-white/20 transition-all duration-200 focus:border-brand-teal focus:bg-brand-teal/5 focus:shadow-[0_0_0_3px_rgba(70,192,186,0.12)] focus:outline-none disabled:opacity-50 ${className}`}
    {...props}
  />
);
